import { formInput, formRadioGroup, formRow, formSelect } from '@rocketfinancialcorp/rocket-ui/form';

import { Patterns } from '../patterns';

const baseExpressions = {
  'props.disabled': 'model.cardOrBankAccount === "card" || model.category === "INTERNAL" || !!model.isEdit',
};

const isIbanCurrency = 'model.currency === "EUR"';

const accountNumberExpressions = {
  ...baseExpressions,
  'props.required': `model.cardOrBankAccount === "bankAccount" && !model.isEdit && !(${isIbanCurrency})`,
  hide: `(${isIbanCurrency}) || (!!model.bankAccount?.iban && !!model.isEdit)`,
};

const routingNumberExpressions = {
  ...baseExpressions,
  'props.required': `model.cardOrBankAccount === "bankAccount" && !model.isEdit && !(${isIbanCurrency})`,
  hide: isIbanCurrency,
};

const alwaysRequiredExpressions = {
  ...baseExpressions,
  'props.required': 'model.cardOrBankAccount === "bankAccount" && !model.isEdit',
};

export const bankAccountFields = [
  formRow([
    formRadioGroup({
      key: 'subtype',
      label: 'Bank Account Type',
      props: {
        options: [
          { label: 'Checking', value: 'CHECKING' },
          { label: 'Saving', value: 'SAVING' },
        ],
      },
      defaultValue: 'CHECKING',
      expressions: baseExpressions,
    }),
  ]),
  formRow([
    formSelect({
      key: 'currency',
      label: 'Currency',
      props: {
        options: [
          { label: 'USD - US Dollar', value: 'USD' },
          { label: 'CAD - Canadian Dollar', value: 'CAD' },
          { label: 'EUR - Euro', value: 'EUR' },
        ],
      },
      defaultValue: 'USD',
      expressions: {
        ...baseExpressions,
        'props.required': 'model.cardOrBankAccount === "bankAccount" && !model.isEdit',
      },
    }),
  ]),
  formRow([
    formInput({ key: 'bankAccount.bankName', label: 'Bank Name', expressions: alwaysRequiredExpressions }),
    formInput({
      key: 'bankAccount.routingNo',
      label: 'Routing No',
      props: { minLength: 9, maxLength: 9 },
      expressions: routingNumberExpressions,
    }),
  ]),
  formRow([
    formInput({
      key: 'bankAccount.nameOnAccount',
      label: 'Name on Account',
      props: { pattern: Patterns.GENERIC_NAME, minLength: 1, maxLength: 100 },
      validation: { messages: { pattern: 'Enter a valid Name on Account' } },
      expressions: alwaysRequiredExpressions,
    }),
  ]),
  formRow([
    formInput({
      key: 'bankAccount.accountNumber',
      label: 'Account Number',
      props: {
        minLength: 4,
        maxLength: 20,
      },
      expressions: accountNumberExpressions,
    }),
  ]),
  formRow([
    formInput({
      key: 'bankAccount.accountNumberConfirm',
      label: 'Confirm Account Number',
      expressions: {
        ...accountNumberExpressions,
        'props.disabled':
          'model.cardOrBankAccount === "card" || model.category === "INTERNAL" || !model.bankAccount?.accountNumber || !!model.isEdit',
      },
    }),
  ]),
  formRow([
    formInput({
      key: 'bankAccount.iban',
      label: 'IBAN',
      props: {
        pattern: Patterns.IBAN,
        minLength: 15,
        maxLength: 34,
      },
      validation: { messages: { pattern: 'Enter a valid IBAN' } },
      expressions: {
        'props.disabled': 'model.cardOrBankAccount === "card" || model.category === "INTERNAL" || !!model.isEdit',
        'props.required': `model.cardOrBankAccount === "bankAccount" && !model.isEdit && (${isIbanCurrency})`,
        hide: `!(${isIbanCurrency})`,
      },
    }),
  ]),
  formRow([
    formInput({
      key: 'bankAccount.bic',
      label: 'BIC',
      props: {
        pattern: Patterns.BIC,
        minLength: 8,
        maxLength: 11,
      },
      validation: { messages: { pattern: 'Enter a valid BIC' } },
      expressions: {
        'props.disabled': 'model.cardOrBankAccount === "card" || model.category === "INTERNAL" || !!model.isEdit',
        'props.required': 'false',
        hide: `!(${isIbanCurrency})`,
      },
    }),
  ]),
];
